import React, { useState, useEffect } from 'react';

const images = [
  '/lovable-uploads/5fb94cc8-1e26-466c-adf6-0eae60bf3fd9.png',
  '/lovable-uploads/7400bf2e-c0ac-4ed7-a168-f5e8848c6f5b.png',
  '/lovable-uploads/d7b14f14-ae1a-43e8-ab1d-cf6e8a27c8f7.png',
  '/lovable-uploads/97dc1f63-1fdf-4160-ba79-c0ffb7f2bd14.png',
  '/lovable-uploads/f2c4fc6d-1c1c-4b6f-9f6b-6dcb45d6766c.png',
  '/lovable-uploads/c4e164ef-ba23-44a0-b450-b99036857634.png',
  '/lovable-uploads/999e526b-791f-4d00-b374-4f13d679811c.png'
];

const HeroSlider: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    console.log('🖼️ HeroSlider: Inicializando com', images.length, 'imagens');
    
    try {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => {
          const nextIndex = prevIndex === images.length - 1 ? 0 : prevIndex + 1;
          console.log('🖼️ HeroSlider: Mudando para imagem', nextIndex);
          return nextIndex;
        });
      }, 8000);

      return () => {
        console.log('🖼️ HeroSlider: Limpando interval');
        clearInterval(interval);
      };
    } catch (error) {
      console.error('🚨 HeroSlider: Erro no useEffect:', error);
    }
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden">
      {images.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-[2500ms] ease-in-out ${
            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            transitionProperty: 'opacity',
            transitionDuration: '2.5s',
            transitionTimingFunction: 'ease-in-out'
          }}
        />
      ))}
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
    </div>
  );
};

export default HeroSlider;